import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-angular-device-information',
  template: `
    <p>
      angular-device-information works!
    </p>
  `,
  styles: [
  ]
})
export class AngularDeviceInformationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
